export default "__VITE_ASSET__DRNio1zN__"